
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class TriangularSubdivisionEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
         const size = (400 + layerIndex * 150) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, size );
        const scale = config.parallaxScale || 1.0;
        const iterations = Math.floor(3 * (config.parallaxComplexity || 1.0));

        ctx.strokeStyle = pc.color;

        const drawTri = (x1: number, y1: number, x2: number, y2: number, x3: number, y3: number, level: number) => {
             if (level === 0) {
                 ctx.beginPath();
                 ctx.moveTo(x1, y1);
                 ctx.lineTo(x2, y2);
                 ctx.lineTo(x3, y3);
                 ctx.closePath();
                 ctx.stroke();
                 return;
             }

             const mx12 = (x1 + x2) / 2;
             const my12 = (y1 + y2) / 2;
             const mx23 = (x2 + x3) / 2;
             const my23 = (y2 + y3) / 2;
             const mx31 = (x3 + x1) / 2;
             const my31 = (y3 + y1) / 2;

             drawTri(x1, y1, mx12, my12, mx31, my31, level - 1);
             drawTri(x2, y2, mx12, my12, mx23, my23, level - 1);
             drawTri(x3, y3, mx31, my31, mx23, my23, level - 1);
             drawTri(mx12, my12, mx23, my23, mx31, my31, level - 1);
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += size) {
                for (let y = y1; y <= y2; y += size) {
                    const s = size * 0.5 * scale;
                    drawTri(x, y - s, x - s, y + s, x + s, y + s, iterations);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
